/* FAQ (PRO system) — sections/cs-faq-section.liquid
   Animates each answer open and closed. With data-one-at-a-time, opening a
   question closes the others in the same section. */
if (!customElements.get('cs-faq')) {
  customElements.define(
    'cs-faq',
    class CsFaq extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('.cs-faq__item')];
        this.items.forEach((item) => {
          item.querySelector('.cs-faq__question').addEventListener('click', (event) => {
            event.preventDefault();
            if (item.open) {
              this.close(item);
            } else {
              if (this.hasAttribute('data-one-at-a-time')) {
                this.items.filter((other) => other !== item && other.open).forEach((other) => this.close(other));
              }
              this.open(item);
            }
          });
        });
      }

      animate(item, from, to, done) {
        const answer = item.querySelector('.cs-faq__answer');
        item._animation?.cancel();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return done?.();
        item._animation = answer.animate({ height: [`${from}px`, `${to}px`] }, {
          duration: 350,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        });
        item._animation.onfinish = () => {
          item._animation = null;
          done?.();
        };
      }

      open(item) {
        item.open = true;
        const height = item.querySelector('.cs-faq__answer').offsetHeight;
        this.animate(item, 0, height);
      }

      close(item) {
        const height = item.querySelector('.cs-faq__answer').offsetHeight;
        this.animate(item, height, 0, () => (item.open = false));
      }
    }
  );
}
